import React from "react";

export default function VinInfo(props) {
  
  const { vehicalDetails, driverDetails } = props.data;
  const {defaultSearchValue}=props;

  const getSearchParameter = () => {
    let type = localStorage.getItem("searchElement");
    return type;
  };
  const getHighlightedText = (text, highlight) => {
    // Split text on highlight term, include term itself into parts, ignore case

    if(text){
      let parts = text.split(new RegExp(`(${highlight})`, "gi"));
      return (
        <span>
          {parts.map((part) =>
            part.toLowerCase() === highlight.toLowerCase() ? (
              <span style={{ background: "yellow" }}>{part}</span>
            ) : (
              part
            ),
          )}
        </span>
      );
    }
  
  };
  return (
    <div className="card mt-2" style={{ border: "none" }}>
      <div
        className={"card-body"}
        style={{
          borderRadius: "4px",
          backgroundColor: "#f5fbff",
          padding: "15px 12px 15px 12px",
        }}
      >
        <div className={"row"}>
          <div className={"col-md-6"}>
            {vehicalDetails.map((vinInfo, index) => {
              return (
                <div key={index} className={"flex-box mt-1"}>
                  <div className={"col-md-5"}>
                    <div className={"search-label"}>VIN {index + 1}</div>
                    <div className={"search-items-content-vin"}>
                    {getSearchParameter() === "vin"
                    ? getHighlightedText(vinInfo.vin, defaultSearchValue)
                    : vinInfo.vin}
                    </div>
                  </div>
                  <div className={"col-md-2"}>
                    <div className={"search-label"}>Year</div>
                    <div className={"search-items-content-vin"}>
                      {vinInfo.vehYear}
                    </div>
                  </div>
                  <div className={"col-md-2"}>
                    <div className={"search-label"}>Make</div>
                    <div className={"search-items-content-vin"}>
                      {vinInfo.vehMake}
                    </div>
                  </div>
                  <div className={"col-md-3"}>
                    <div className={"search-label"}>Model</div>
                    <div className={"search-items-content-vin"}>
                      {vinInfo.vehModel1}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          <div className={"col-md-6"}>
            {driverDetails.map((driverInfo, index) => {
              return (
                <div key={index} className={"flex-box mt-1"}>
                  <div className={"col-md-3"}>
                    <div className={"search-label"}>Driver {index + 1} </div>
                    <div className={"search-items-content-vin"}>
                      {driverInfo.firstName} , {driverInfo.lastName}
                    </div>
                  </div>
                  <div className={"col-md-3"}>
                    <div className={"search-label"}> License No.</div>
                    <div className={"search-items-content-vin"}>
                    {getSearchParameter() === "licenseNo"
                    ? getHighlightedText(driverInfo.licenseNo, defaultSearchValue)
                    : driverInfo.licenseNo}              
                    </div>
                  </div>
                  <div className={"col-md-3"}>
                    <div className={"search-label"}> Relation</div>
                    <div className={"search-items-content-vin"}>
                      {driverInfo.relationToInsured}
                    </div>
                  </div>
                  <div className={"col-md-3"}>
                    <div className={"search-label"}> Excluded</div>
                    <div className={"search-items-content-vin"}>
                      {driverInfo.exclude ? "Y" : "N"}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        {/* ); */}
        {/* })} */}
      </div>
    </div>
  );
}
